var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('html-editor',_vm._b({attrs:{"error-message":_vm.errorMessage,"label":_vm.label},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}},'html-editor',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }